module.exports = __webpack_public_path__ + "static/media/itel.51cd37b7.png";